/**
 * AG sticky bar sizes
 * A size button in the mobile sticky add-to-cart bar selects the same size in the
 * main variant picker. The theme then updates the price, stock and the sticky bar itself.
 */
(function () {
  if (window.__agStickySizes) return;
  window.__agStickySizes = true;

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    var button = target && target.closest('[data-ag-sticky-size]');
    if (!button) return;

    var valueId = button.getAttribute('data-ag-sticky-size');
    var section = button.closest('.shopify-section') || document;

    // main picker only (not product cards in recommendations)
    var inputs = section.querySelectorAll('variant-picker input[data-option-value-id="' + valueId + '"]');
    var input = null;
    inputs.forEach(function (el) {
      if (!input && !el.closest('product-card')) input = el;
    });

    if (input) {
      if (input.checked) return;
      button.parentElement.querySelectorAll('[data-ag-sticky-size]').forEach(function (el) {
        el.setAttribute('aria-pressed', el === button ? 'true' : 'false');
      });
      input.click();
      return;
    }

    // dropdown pickers
    var option = section.querySelector('variant-picker option[data-option-value-id="' + valueId + '"]');
    if (option && option.parentElement instanceof HTMLSelectElement) {
      var select = option.parentElement;
      if (select.value === option.value) return;
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();
